import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import CourseView from './CourseViewV2';

const CourseViewWrapper = () => {
  useEffect(() => {
    window.scrollTo?.({ top: 0 });
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <CourseView />
    </div>
  );
};

export default observer(CourseViewWrapper);
